import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import { useLanguage } from "../tools/LanguageContext";
import axios from "axios";

function Home() {
  const { translations, toggleLanguage } = useLanguage();
  const token = localStorage.getItem("token");
  const username = localStorage.getItem("username");
  const [isAdmin, setIsAdmin] = useState(false);
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(false);
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const cardData = [
    { title: translations.freeBets, value: translations.freeBetsDesc, route: "free_bets", button: "learnMore" },
    { title: translations.vip, value: translations.vipDesc, route: "vip", button: "learnMore" },
    { title: translations.statistics, value: translations.statisticsDesc, route: "statistics", button: "learnMoreStats" },
    { title: translations.articles, value: translations.articlesDesc, route: "articles", button: "learnMoreArticles" },
    { title: translations.algorithm, value: translations.algorithmDesc, route: "inprogress", button: "" },
    { title: translations.poker, value: translations.pokerDesc, route: "inprogress", button: "" },
  ];

  useEffect(() => {
    AOS.init();

    const fetchAdminStatus = async () => {
      if (!token) {
        return;
      }

      try {
        const response = await axios.get("https://artofbetting.gr/api/get_admin_status", {
          headers: {
            "Authorization": token,
          }
        });
        setIsAdmin(response.data.admin_status);
      } catch (error) {
        if (error.response?.status === 401) {
          alert(translations.alertTokenExpired);
          // Redirect στο home
          localStorage.removeItem("token");
          navigate("/");
        }
      }
    };

    fetchAdminStatus();
  }, [token, navigate, translations.alertTokenExpired]);

  return (
    <div className="bg-gray-900 text-white min-h-screen flex flex-col overflow-x-hidden">
      {/* Header */}
      <header className="flex flex-col justify-center items-center p-4 bg-gray-800">
        <h1 className="text-3xl font-bold text-center mb-4">{translations.title}</h1>
        <a href="https://www.facebook.com/profile.php?id=100063646835148" target="_blank" rel="noopener noreferrer" className="absolute left-4 top-4 transform">
          <img src="images/fb.png" alt="fb" className="w-8 h-auto" />
        </a>
        <a href="https://www.instagram.com/artofb2018?igsh=aW53OTA5OTJuYWtw" target="_blank" rel="noopener noreferrer" className="absolute right-4 top-4 transform">
          <img src="images/insta.png" alt="instagram" className="w-8 h-auto" />
        </a>
        <div className="flex flex-wrap justify-center gap-4">
          {token ? (
            <>
              <div className="relative inline-block text-left">
                <button className="bg-green-800 px-4 py-2 rounded text-lg hover:bg-green-900" onClick={toggleDropdown}>
                  {username}
                </button>

                {/* Dropdown Menu */}
                {isOpen && (
                  <div className="absolute left-0 mt-2 w-48 bg-gray-800 text-white rounded shadow-lg z-10">
                    <ul>
                      <Link to="subscription">
                      <li className="px-4 py-2 hover:bg-gray-700 cursor-pointer">
                        {translations.subscription}
                      </li>
                      </Link>
                      <Link to="profile">
                      <li className="px-4 py-2 hover:bg-gray-700 cursor-pointer">
                        {translations.profile}
                      </li>
                      </Link>
                      {isAdmin &&
                        <Link to="traffic">
                        <li className="px-4 py-2 hover:bg-gray-700 cursor-pointer">
                          {translations.traffic}
                        </li>
                        </Link>
                      }
                      <li className="px-4 py-2 hover:bg-gray-700 cursor-pointer" onClick={() => {
                          localStorage.removeItem("token");
                          navigate("/");
                        }}>
                        {translations.logout}
                      </li>
                    </ul>
                  </div>
                )}
              </div>
            </>
          ) : (
            <>
              <Link to="/login">
                <button className="bg-green-800 px-4 py-2 rounded text-lg hover:bg-green-900">
                  {translations.login}
                </button>
              </Link>
              <Link to="/register">
                <button className="bg-green-800 px-4 py-2 rounded text-lg hover:bg-green-900">
                  {translations.register}
                </button>
              </Link>
            </>
          )}
          <button
            onClick={toggleLanguage}
            className="bg-green-800 px-4 py-2 rounded text-lg hover:bg-green-900"
          >
            {translations.switchTo}
          </button>
        </div>
      </header>

      {/* Main Section */}
      <main className="p-4 flex-grow">
        <section className="flex flex-col md:flex-row items-center md:space-x-6 space-y-6 md:space-y-0">
          <div className="flex-1 text-center md:text-left">
            <h2 className="text-4xl font-bold mb-4">{translations.slogan}</h2>
            <Link to="about">
              <button className="bg-green-800 px-6 py-3 rounded text-lg hover:bg-green-900 mt-4">
                {translations.aboutUs}
              </button>
            </Link>
          </div>
          <div className="flex-1">
            <img
              src="images/art_of_betting_nobg.png"
              alt="Stadium"
              className="rounded-lg mx-auto"
            />
          </div>
        </section>

        {/* Cards Section */}
        <section className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          {cardData.map((card, index) => (
            <div
              key={index}
              className="p-4 rounded-lg shadow-lg bg-green-800 text-center"
              data-aos={index % 2 === 0 ? "fade-left" : "fade-right"}
              data-aos-offset="170"
              data-aos-duration="1000"
            >
              <h3 className="text-2xl font-bold mb-2">{card.title}</h3>
              <p className="text-lg mb-4">{card.value}</p>
              {card.route === "inprogress" ? (
                <button className="bg-gray-800 text-white px-4 py-2 rounded hover:bg-gray-700">
                  {translations.inprogress} {/* Αντικαθιστούμε το κείμενο με το inprogress */}
                </button>
              ) : (
                <Link to={card.route}>
                  <button className="bg-gray-800 text-white px-4 py-2 rounded hover:bg-gray-700">
                    {translations[card.button]}
                  </button>
                </Link>
              )}
            </div>
          ))}
        </section>
      </main>

      <footer className="relative w-full bg-gray-900 py-8">
        <div className="flex flex-col items-center justify-between w-full">
          <p className="text-xl font-bold border-b border-t p-4 mb-8">© Copyright 2025 Art Of Betting</p>
          <p className="text-lg font-bold border-b border-t p-2 mb-8 text-center">
            <span className="font-semibold">Διαφημιστειτε εδώ:</span>{' '}
            <a href="mailto:artofbetting2025@gmail.com" className="hover:underline">
              artofbetting2025@gmail.com
            </a>
          </p>

          <div className="flex items-center justify-between w-2/5 mb-8">
            <a href="https://www.kethea.gr/" target="_blank" rel="noopener noreferrer" className="w-1/5 mr-8">
              <img
                src="images/21.svg"
                alt="21+"
                className="w-full h-auto"
              />
            </a>

            <a href="https://www.kethea.gr/" target="_blank" rel="noopener noreferrer" className="w-4/5">
              <img
                src="images/kethea.svg"
                alt="kethea"
                className="w-full h-auto"
              />
            </a>
          </div>

          <a href="https://certifications.gamingcommission.gov.gr/publicRecordsOnline/SitePages/AffiliatesOnline.aspx" target="_blank" rel="noopener noreferrer">
            <img
              src="images/eeep.png"
              alt="eeep"
              className="w-full h-auto border-b border-t p-4"
            />
          </a>
        </div>
      </footer>
    </div>
  );
}

export default Home;
